<template>
    <div class="form-field" :class="{ required }">

        <ValidationProvider :key="name" :name="name" v-slot="{ errors }" persist :rules="rules">

            <div class="form-group">

                <label class="form-field-label" :for="name" :class="{'validation-error': errors.length > 0 }">{{label}}</label>

                <select class="form-control" :class="{'validation-error': errors.length > 0 }"
                        :name="name"
                        v-bind:value="value"
                        @change="$emit('input', $event.target.value)"
                        @input="$emit('input', $event.target.value)"
                >
                    <option value="">Choose one...</option>
                    <option v-for="(o, idx) in options" :key="idx" :value="o.value">{{o.text}}</option>
                </select>

                <p v-if="errors[0]" class="validation-error">{{ errors[0] }}</p>

            </div>

        </ValidationProvider>

    </div>
</template>

<script>
    import {ValidationProvider} from "vee-validate"

    export default {
        name: "SelectInput",
        props: ["name", "label", "options", "value", "rules", "required"],
        components: {
            ValidationProvider
        }
    }
</script>

<style lang="scss" scoped>

    .required {

        .form-field-label:after {
            content: '*';
            color: red;
        }
    }

    input {
        display: none;
    }

    input ~ label > .bi-circle-fill,
    input:checked ~ label > .bi-circle {
        display: none;
    }

    input ~ label > .bi-circle,
    input:checked ~ label > .bi-circle-fill {
        display: inline-block;
    }
</style>
